//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { mapMutations, mapGetters } from 'vuex';
// import ImageBlock from 'components/blocks/Image.vue'

export default {
  block: 'headerFull',
  props: ['data'],
  components: {
    // ImageBlock,
  },
  computed: {
    ...mapGetters([
      'isMobile',
    ]),
  },
  methods: {
    ...mapMutations([
      'openGetStartedMenu',
    ]),
    callback(){
      // TBD Ugly solution. Did not add the possibility to provide
      // any callback function (since callback is only used for this component and 
      // for this partucular use case)
      this.openGetStartedMenu();
    },
    getBlockModifiers() {
      let bms = this.block;
      if (this.data.blockModifiers) {
        this.data.blockModifiers.forEach( (blockModifier, index) => {
          bms += ' bm-'+blockModifier;
        });
      }

      return bms;
    },
  }
}



// WEBPACK FOOTER //
// ./components/combinedBlocks/HeaderFull.vue